import React from "react";
import { useNavigate } from "react-router-dom";
import { CrudPage } from "@/components/CrudPage";

const columns = [
  { key: "name", label: "氏名", render: (r) => <span className="font-medium">{r.name}</span> },
  { key: "name_kana", label: "フリガナ", render: (r) => <span className="text-muted-foreground">{r.name_kana}</span> },
  { key: "phone", label: "電話番号" },
  { key: "email", label: "メール" },
  { key: "nationality", label: "国籍" },
  { key: "guarantee_company", label: "保証会社" },
];

const fields = [
  { name: "name", label: "氏名", required: true },
  { name: "name_kana", label: "フリガナ" },
  { name: "birth_date", label: "生年月日", type: "date" },
  { name: "phone", label: "電話番号", type: "tel" },
  { name: "email", label: "メール", type: "email" },
  { name: "current_address", label: "現住所", colSpan: 2 },
  { name: "employer", label: "勤務先" },
  { name: "nationality", label: "国籍" },
  { name: "emergency_contact", label: "緊急連絡先", colSpan: 2 },
  { name: "guarantor", label: "保証人" },
  { name: "guarantee_company", label: "保証会社" },
  { name: "note", label: "備考", type: "textarea" },
];

export default function Tenants() {
  const navigate = useNavigate();
  return (
    <CrudPage
      title="入居者管理"
      subtitle="入居者情報（個人情報は権限により管理）"
      endpoint="/tenants"
      resource="tenants"
      columns={columns}
      fields={fields}
      testid="tenants"
      addLabel="入居者を登録"
      searchKeys={["name", "name_kana", "phone", "email"]}
      onView={(r) => navigate(`/tenants/${r.id}/edit`)}
      onMessage={(r) => navigate(`/tenants/${r.id}/messages`)}
    />
  );
}
